import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Sparkles, Heart, CalendarCheck, MessageSquareText, History } from 'lucide-react';

// Static, illustrative recommendations — no AI or recommendation engine is
// implemented. These are general live-streaming best practices, not derived
// from this creator's real audience performance.
const RECOMMENDATIONS = [
  { key: 'engagement', icon: Heart, title: 'Improving audience engagement', body: 'Ask viewers questions and respond to chat in real time to keep the audience active.' },
  { key: 'schedule', icon: CalendarCheck, title: 'Maintaining a consistent live schedule', body: 'Streaming at the same days and times helps your audience know when to return.' },
  { key: 'interaction', icon: MessageSquareText, title: 'Encouraging viewer interaction', body: 'Shout-outs, polls, and reaction prompts tend to increase chat participation.' },
  { key: 'review', icon: History, title: 'Reviewing previous stream performance', body: 'Once Stream History has data, look back at what worked before your next session.' },
];

/** Live Recommendations detail dialog — compact, clearly-illustrative
 * suggestions. No personalized or AI-generated insight is implied. */
export default function LiveRecommendationsDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="live-recommendations-dialog">
        <DialogHeader><DialogTitle className="text-white flex items-center gap-2"><Sparkles className="h-4.5 w-4.5 text-amber-400" />Live Recommendations</DialogTitle></DialogHeader>
        <Badge variant="outline" className="w-fit text-[10px] border-amber-500/30 text-amber-400 uppercase tracking-wider">Illustrative Recommendations</Badge>
        <p className="text-xs text-[#8A93A6]">General live-stream improvement suggestions — not yet based on your real audience performance.</p>

        <div className="space-y-3">
          {RECOMMENDATIONS.map((rec) => (
            <Card key={rec.key} className="glass border-white/5" data-testid={`live-rec-${rec.key}`}>
              <CardContent className="pt-4 pb-4 space-y-1.5">
                <span className="flex items-center gap-2 text-sm font-medium text-white"><rec.icon className="h-4 w-4 text-amber-400 shrink-0" />{rec.title}</span>
                <p className="text-xs text-[#8A93A6]">{rec.body}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
